/// <amd-module name="Search/Wiki/Flux/Sources/PivotStateServiceSpy" />

import { ISearchPivotStateService } from "Search/Shared/Base/PivotStateService";
import { IVssPageContext } from "VSS/Platform/Context";
import { serializeFilters } from "Search/Shared/Utils";
import { ActionsHub } from "Search/Wiki/Flux/ActionsHub";
import { WikiSearchRequest, WikiResult, WikiSearchResponse } from 'Search/WebApi/Contracts/Search.Shared';
import { EntityTypeUrlParam } from "Search/Wiki/Constants";
import { IResultsLoadedPayload, ISearchStartedPayload } from "Search/Shared/Base/ActionsHub2";

export class PivotStateServiceSpy {
    private readonly pivotStateService: ISearchPivotStateService;

    constructor(
        private pageContext: IVssPageContext,
        private actionsHub: ActionsHub) {
            this.pivotStateService = this.pageContext.getService<ISearchPivotStateService>("ISearchPivotStateService");
            this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.searchStarted.addListener(this.storeCurrentFilters);
        this.actionsHub.pageInitializationStarted.addListener(this.storeCurrentFilters);
        this.actionsHub.filterReset.addListener(this.resetFilters);
        this.actionsHub.resultsLoaded.addListener(this.storeCurrentResultsCount);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.removeListener(this.storeCurrentResultsCount);
        this.actionsHub.searchStarted.removeListener(this.storeCurrentFilters);
        this.actionsHub.pageInitializationStarted.removeListener(this.storeCurrentFilters);
        this.actionsHub.filterReset.removeListener(this.resetFilters);
    }

    public resetFilters = (): void => {
        this.pivotStateService.resetFilters(EntityTypeUrlParam);
    }

    public storeCurrentFilters = (payload: ISearchStartedPayload<WikiSearchRequest>): void => {
        this.pivotStateService.updateState(EntityTypeUrlParam, serializeFilters(payload.request.filters));
    }

    public storeCurrentResultsCount = (payload: IResultsLoadedPayload<WikiSearchRequest, WikiSearchResponse, WikiResult>): void => {
        const count = payload.response.count;
        this.pivotStateService.updateState(EntityTypeUrlParam, undefined, undefined, { searchtext: payload.request.searchText, count });
    }
}
